export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Key',
          value: 'Key',
        },
      ],
    },
  },
  read:false,
  add:false,
  edit:false,
  delete:false,
}